import { observer } from 'mobx-react-lite';
import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';

interface PropType {
    route: string;
    parameters?: Record<string, string | number | null>;
    children?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    className?: string;
    dataTest?: string;
    isDisabled?: boolean;
}

const Link = observer((props: PropType) => {
    const appState = useAppStateContext();

    const { route, parameters, onClick, className, dataTest, isDisabled, children } = props;

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();

        if (isDisabled === true) {
            console.info('Link is disabled');
            return;
        }

        // this.context.route[toggle ? 'toggle' : 'set'](route, parameters);
        console.info('ROUTER - Link, redirect to', { route, parameters });
        appState.routerBackoffice.redirectToNamespace(route, parameters ?? {});

        if (onClick !== undefined) {
            onClick(e);
        }
    };

    return (
        <a
            href='#'
            className={className}
            onClick={handleClick}
            data-test={dataTest}
        >
            {children}
        </a>
    );
});

// eslint-disable-next-line import/no-default-export
export default Link;
